import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import constants from '../../../constants';
import { Creators as procedureActions } from '../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as requestStatusActions } from '../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as registerActions } from '../../../../../../domain/useCases/procedures/certificateType01/registerUseCase';
import { Creators as periodsWithDebtss } from '../../../../../../domain/useCases/procedures/getPeriodsWithDebts';
import useTitle from '@/presentation/hooks/useTitle';
import CertificateOfStudiesRegisterView from './CertificateOfStudiesRegisterView';
import useProfile from '@/presentation/hooks/useProfile';
import TextHelper from '@/core/helpers/TextHelper';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

const CertificateOfStudiesRegisterViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentPeriod } = useExternalSettings();
  const [showModalErrorRegister, setShowModalErrorRegister] = useState(false);
  const [selectedPeriods, setSelectedPeriods] = useState('');

  const { procedure: procedureSelected } = useSelector(
    (state: any) => state.procedureInformation
  );

  const { data: periodsWithDebts, isLoading: loadingPeriods } = useSelector(
    (state: any) => state.getPeriodsWithDebtsUseCase
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!procedureSelected) {
      history.push('/tramites');
    }
  }, []);

  const upDatePeriods = () =>
    procedureSelected?.periods?.map((period: any) => ({
      ...period,
      isDisabled: period.hasDebts // periodsWithDebts?.includes(period.id)
    })) || [];

  const {
    isLoading: isLoadingRegister,
    requestId: requestIdRegistered,
    isSuccess: isSuccessRegister
  } = useSelector((state: any) => state.registerCertificateType01);

  const profile = useProfile();

  const handlerRegisterPeriod = () => {
    const selPeriods = selectedPeriods.split('-');
    const rnewArr = procedureSelected?.periods.filter(({ id: idv }: any) =>
      selPeriods.some((idc) => idv === idc)
    );
    const args1 = rnewArr.map((n: any) => n.id).join('-');
    const args2 = rnewArr.map((n: any) => n.description).join(', ');

    dispatch(
      registerActions.registerCertificateOfStudies(
        1032,
        {
          value: args1,
          label: args2
        },
        '',
        '',
        null
      )
    );
  };

  useEffect(() => {
    if (isSuccessRegister) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          1032,
          requestIdRegistered
        )
      );
      history.push(
        '/tramites/autogestionables/solicitud/certificado-de-estudios/progreso'
      );
    }
  }, [isSuccessRegister]);

  useEffect(() => {
    if (!procedureSelected) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.certificateOfStudies
        )
      );
    }
  }, []);

  useEffect(() => {
    if (!periodsWithDebts) {
      dispatch(periodsWithDebtss.getPeriodsWithDebts(currentPeriod));
    }
  }, []);

  const handlerSelectedPeriods = (value: any) => {
    setSelectedPeriods(value);
  };

  useTitle('Certificado de estudios registro');
  return (
    <CertificateOfStudiesRegisterView
      procedureSelectedInfo={procedureSelected}
      loadingPeriods={loadingPeriods}
      upDatePeriods={upDatePeriods()}
      onSelectedPeriods={handlerSelectedPeriods}
      selectedPeriods={selectedPeriods}
      onRegisterPeriod={handlerRegisterPeriod}
      isProcessing={isLoadingRegister}
      isRegisterError={showModalErrorRegister}
      handlerErrorClose={setShowModalErrorRegister}
      acadProg={TextHelper.fixRomans(
        TextHelper.capitalize(profile.getValue('acadProg'), false, true)
      )}
    />
  );
};

export default CertificateOfStudiesRegisterViewController;
